import { ref, req, withParams } from "vuelidate/lib/validators/common";

export function numberLessThan(otherProperty: any) {
  return withParams({ type: "numberLessThan", gt: otherProperty }, function(
    value: any,
    parentVm: any
  ) {
    // Check if a value has been passed in
    if (!req(value)) {
      return true;
    }

    // Skip non numbers. Let the other validators handle this.
    if (isNaN(value)) {
      return true;
    }

    // Check if the other property has a value
    const otherValue = ref(otherProperty, this, parentVm);
    if (!req(otherValue)) {
      return true;
    }

    return Number(value) < Number(otherValue);
  });
}

export function dateLessThan(otherProperty: any) {
  return withParams({ type: "dateLessThan", gt: otherProperty }, function(
    value: any,
    parentVm: any
  ) {
    // Check if a value has been passed in
    if (!req(value)) {
      return true;
    }

    // Let the other validators handle proper type validation.
    if (isNaN(Date.parse(value))) {
      return true;
    }

    // Check if the other property has a value
    const otherValue = ref(otherProperty, this, parentVm);
    if (!req(otherValue)) {
      return true;
    }

    return new Date(value) < new Date(otherValue);
  });
}
